import { useYaHit } from '@context/useYaHit';
import LinearProgress from '@material-ui/core/LinearProgress';
import DoneIcon from '@mui/icons-material/Done';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useDelivery from '../../../useDelivery';
import { useRouteSearchTaskStatusSubscribe } from '../useRouteSearchTaskStatusSubscribe';
import RoutesCalculationLoaderStyledContainer from './StyledComponents';

const RoutesCalculationLoader = () => {
  const { t } = useTranslation(['RoutesListComponent', 'PageNames']);

  const { useRouteSearchTaskStatus } = useDelivery();
  const [routeSearchTaskStatus] = useRouteSearchTaskStatus().useState();
  const {
    baseGraphBuildIsDone,
    buildRoutesIsDone,
    groupRoutesIsDone,
    calculateGroupsIsDone,
    typeSearch,
  } = routeSearchTaskStatus;

  useYaHit({});

  useRouteSearchTaskStatusSubscribe();

  const isSearchCompeleteRoutes = typeSearch === 'SEARCH_COMPLETE_ROUTES';

  return (
    <RoutesCalculationLoaderStyledContainer>
      <LinearProgress />
      <Alert icon={false} severity="info" sx={{ width: '100%' }}>
        <div className="message-wrapper">
          <div className="status-wrapper">
            <AlertTitle sx={{ marginRight: '20px' }}>
              {t('RoutesListComponent:routesList.searchSteps.step1')}
            </AlertTitle>
            {baseGraphBuildIsDone ? (
              <DoneIcon sx={{ fontSize: '26px', color: '#0EAB70', marginTop: '-4px' }} />
            ) : (
              <div className="spinner-wrapper">
                <CircularProgress color="secondary" size={18} />
              </div>
            )}
          </div>
          <div className="status-wrapper">
            <AlertTitle sx={{ marginRight: '20px' }}>
              {t('RoutesListComponent:routesList.searchSteps.step2')}
            </AlertTitle>{' '}
            {buildRoutesIsDone ? (
              <DoneIcon sx={{ fontSize: '26px', color: '#0EAB70', marginTop: '-4px' }} />
            ) : (
              <div className="spinner-wrapper">
                <CircularProgress color="secondary" size={18} />{' '}
              </div>
            )}
          </div>
          <div className="status-wrapper">
            <AlertTitle sx={{ marginRight: '20px' }}>
              {t('RoutesListComponent:routesList.searchSteps.step3')}
            </AlertTitle>{' '}
            {groupRoutesIsDone ? (
              <DoneIcon sx={{ fontSize: '26px', color: '#0EAB70', marginTop: '-4px' }} />
            ) : (
              <div className="spinner-wrapper">
                <CircularProgress color="secondary" size={18} />{' '}
              </div>
            )}
          </div>
          <div className="status-wrapper">
            <AlertTitle sx={{ marginRight: '20px' }}>
              {t('RoutesListComponent:routesList.searchSteps.step4')}
            </AlertTitle>{' '}
            {calculateGroupsIsDone ? (
              <DoneIcon sx={{ fontSize: '26px', color: '#0EAB70', marginTop: '-4px' }} />
            ) : (
              <div className="spinner-wrapper">
                <CircularProgress color="secondary" size={18} />{' '}
              </div>
            )}
          </div>
        </div>
      </Alert>

      <Alert color={isSearchCompeleteRoutes ? 'info' : 'warning'} severity={'info'}>
        <AlertTitle>
          {t(
            'RoutesListComponent:routesList.' +
              (isSearchCompeleteRoutes ? 'isProcess_1' : 'isProcess_3')
          )}
        </AlertTitle>
        {isSearchCompeleteRoutes && <>{t('RoutesListComponent:routesList.isProcess_2')}</>}
      </Alert>
    </RoutesCalculationLoaderStyledContainer>
  );
};

export { RoutesCalculationLoader };
